import { IResourceComponentsProps } from "@refinedev/core";

import { ChatMessageCreateEdit } from "./components/ChatMessageCreateEdit";

export const ChatMessageEdit: React.FC<IResourceComponentsProps> = () => {
  return <ChatMessageCreateEdit type="edit" />;
};
